import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Radio, { RADIO_NAME } from './Radio';

var RadioGroup = function RadioGroup(props) {
  var initialSelected = '';
  var valueSelected = props.valueSelected,
      defaultSelected = props.defaultSelected,
      style = props.style,
      className = props.className,
      inline = props.inline,
      onChange = props.onChange;

  if (valueSelected !== undefined) {
    initialSelected = valueSelected;
  } else if (defaultSelected !== undefined) {
    initialSelected = defaultSelected;
  }

  var _useState = useState(initialSelected),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var handleChange = useCallback(function (event, selectedItem) {
    setSelected(selectedItem);
    if (onChange) onChange(event, selectedItem);
  }, [onChange]);
  var composedStyle = inline ? _objectSpread({}, style, {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap'
  }) : _objectSpread({}, style);
  var options = React.Children.map(props.children, function (option) {
    var _option$props = option.props,
        name = _option$props.name,
        value = _option$props.value,
        label = _option$props.label,
        onCheck = _option$props.onCheck,
        other = _objectWithoutProperties(_option$props, ["name", "value", "label", "onCheck"]);

    return option.type && option.type.displayName === RADIO_NAME ? React.createElement(Radio, _extends({}, other, {
      name: props.name,
      key: option.props.value,
      value: option.props.value,
      label: option.props.label,
      onCheck: handleChange,
      checked: option.props.value === selected,
      style: _objectSpread({
        marginRight: '20px'
      }, option.props.style)
    })) : option;
  }, _this);
  return React.createElement("div", {
    style: composedStyle,
    className: className
  }, options);
};

export default RadioGroup;
RadioGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  defaultSelected: PropTypes.any,
  // eslint-disable-line react/forbid-prop-types
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  style: StylePropType,
  inline: PropTypes.bool,
  valueSelected: PropTypes.any // eslint-disable-line react/forbid-prop-types

};
RadioGroup.defaultProps = {
  className: '',
  inline: false
};